<template>
  <div class="left_block groups">
    <p class="header">Все группы</p>

    <GroupsFilter
      :rows="rows"
      :search="search"
      @change="loadData"
      @delete-checked="deleteChecked"
      @open-modal="openModal"
    />

    <GroupsTable
      :is-loading="isLoading"
      :rows="rows"
      :groups-list="groupsList"
      :total-count="totalCount"
      @delete="deleteGroup"
      @changePage="changePage"
      @init-sort="initSort"
    />

    <b-modal :active.sync="isModalOpen" has-modal-card scroll="keep">
      <GroupsCreate
        :new-group="newGroup"
        :modal-info="modal"
        @close-modal="closeModal"
        @create="create"
      />
    </b-modal>
  </div>
</template>

<script>
import GroupsFilter from '@/components/admin/groups/GroupsFilter';
import GroupsCreate from '@/components/admin/groups/GroupsCreate';
import GroupsTable from '@/components/admin/groups/GroupsTable';
import { toastInfo } from '@/lib/toastCfg';

export default {
  components: { GroupsFilter, GroupsCreate, GroupsTable },
  data() {
    return {
      isModalOpen: false,
      isLoading: true,
      rows: { checked: [] },
      search: {
        name: '',
        page: 1,
        sort: 'name',
        sort_type: 'desc',
      },
      newGroup: { name: '' },
      modal: {
        header: 'Добавление группы',
        button: 'Добавить',
        action: 'create',
        creation: true,
        required: true,
      },
    }
  },
  computed: {
    groupsList() {
      return this.$store.state.groups.groupsList.groups;
    },
    totalCount() {
      return this.$store.state.groups.groupsList.total;
    },
  },
  methods: {
    initSort(fieldName, sortType) {
      this.search.sort_type = sortType;
      this.search.sort = fieldName;
      this.loadData();
    },
    loadData() {
      this.isLoading = true;
      const qs = require('qs');
      const params = {};
      Object.keys(this.search).forEach((el) => {
        if (this.search[el] && this.search[el] !== 0) {
          params[el] = this.search[el];
        }
      });
      this.$axios2
        .get('groups?' + qs.stringify(params))
        .then((resp) => {
          this.isLoading = false;
          this.$store.commit('setGroupsList', { list: resp.data });
        })
        .catch((err) => {
          this.$errorToast(err);
          this.isLoading = false;
        });
    },
    changePage(pageNumber) {
      this.search.page = pageNumber;
      this.loadData();
    },
    deleteGroup(groupID) {
      this.$axios2
        .delete('groups/' + groupID)
        .then(() => {
          this.$buefy.toast.open(toastInfo());
          this.loadData();
        })
        .catch(this.$errorToast);
    },
    deleteChecked() {
      for (let i = 0; i < this.rows.checked.length; i++) {
        this.deleteGroup(this.rows.checked[i].id);
      }
      this.rows.checked = [];
    },
    openModal() {
      this.newGroup = { name: '' };
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    create() {
      this.$axios2.post('groups', this.newGroup).then(() => {
        this.$buefy.toast.open(toastInfo());
        this.loadData();
        this.closeModal();
      })
      .catch(this.$errorToast);
    },
  },
  mounted() {
    this.loadData();
  },
}
</script>
